/** Format region labels for search API and display. */
export function formatRegionTextsForApi(regions: string[]): string[] {
  return regions.map((r) => r.trim()).filter(Boolean);
}

/** True when search should run nationwide (empty or full catalog picked). */
export function isWholeCountrySearchSelection(selectedCount: number, catalogCount: number): boolean {
  if (selectedCount === 0) return true;
  return catalogCount > 0 && selectedCount >= catalogCount;
}

/** Collapse full catalog selection to [] so backend skips region hard-filter. */
export function normalizeSearchRegionSelection(regions: string[], catalogCount: number): string[] {
  const cleaned = formatRegionTextsForApi(regions);
  if (isWholeCountrySearchSelection(cleaned.length, catalogCount)) {
    return [];
  }
  return cleaned;
}

/**
 * Click a federal subject on the search form.
 * Nationwide (empty or full catalog) → keep only that subject.
 * Selecting every subject again collapses back to nationwide.
 */
export function toggleSearchRegion(current: string[], name: string, catalogCount: number): string[] {
  const trimmed = name.trim();
  if (!trimmed) return current;
  if (isWholeCountrySearchSelection(current.length, catalogCount)) {
    return [trimmed];
  }
  const next = current.includes(trimmed)
    ? current.filter((v) => v !== trimmed)
    : [...current, trimmed];
  if (isWholeCountrySearchSelection(next.length, catalogCount) && next.length > 0) {
    return [];
  }
  return next;
}

/** Parse region_text from API: plain label or JSON array (multi-region schedules/searches). */
export function parseRegionTextsField(regionText?: string | null): string[] {
  const s = (regionText ?? '').trim();
  if (!s) return [];
  if (s.startsWith('[')) {
    try {
      const arr = JSON.parse(s) as unknown;
      if (Array.isArray(arr)) {
        return formatRegionTextsForApi(arr.filter((x): x is string => typeof x === 'string'));
      }
    } catch {
      /* fall through */
    }
  }
  return [s];
}

export function formatRegionsSummary(regions: string[], wholeCountryLabel: string, catalogCount = 0): string {
  if (isWholeCountrySearchSelection(regions.length, catalogCount)) return wholeCountryLabel;
  return regions.join(', ');
}
